module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-500.725188c.eot";